import { type UseQueryResult, useQuery } from 'react-query';
import {
  OptionExerciseService,
  Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { TableParamsType } from '../../types/common';

const useGetISOQualifiedListByParticipantId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto[] | undefined,
  unknown
> => {
  const { filter, sorting, skipCount } = tableInfo;
  const iSOQualifiedListByParticipantId = useQuery(
    ['getISOQualifiedListByParticipantId', filter, sorting, skipCount, id],
    async () => {
      if (id) {
        return await handleRequest(
          OptionExerciseService?.getApiAwardApiAppOptionExerciseIsoQualifiedList(id)
        );
      }
    }
  );

  return iSOQualifiedListByParticipantId;
};

export default useGetISOQualifiedListByParticipantId;
